module.exports = __webpack_public_path__ + "img/1e2020d.png";